import * as React from 'react';

import { Checkbox } from '@coursera/coursera-ui';

import type { FilterOption } from 'bundles/enterprise-admin-drawers/components/types';

import _t from 'i18n!nls/admin-dashboard';

type Props = {
  filterOptions: FilterOption[];
  selectedFilterOptions: FilterOption[];
  onChange?: (nextValue: FilterOption[]) => void;
};

class FilterListSelectAllOption extends React.Component<Props> {
  handleOnChange = () => {
    const { filterOptions, selectedFilterOptions, onChange } = this.props;
    const allSelected = filterOptions.length <= selectedFilterOptions.length;

    if (onChange) {
      onChange(allSelected ? [] : filterOptions);
    }
  };

  render() {
    const { filterOptions, selectedFilterOptions, onChange } = this.props;

    if (!onChange) {
      return null;
    }

    const allSelected = filterOptions.length <= selectedFilterOptions.length;

    return (
      <div className="c-filterOption selectAllOption">
        <div className="horizontal-box w-100">
          <div className="flex-2">
            <Checkbox checked={allSelected} value="~~all~~" onChange={this.handleOnChange} size={20}>
              <span>{_t('Select All')}</span>
            </Checkbox>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterListSelectAllOption;
